import { Link } from "react-router-dom";

type AppFooterProps = {
	onOpenCookieSettings: () => void;
};

export default function AppFooter({ onOpenCookieSettings }: AppFooterProps) {
	return (
		<footer className="border-t border-slate-200 bg-white">
			<div className="mx-auto w-full max-w-6xl px-6 py-8">
				<div className="grid grid-cols-1 gap-8 sm:grid-cols-3 lg:grid-cols-3">
					<div>
						<p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
							Product
						</p>
						<div className="mt-3 flex flex-col items-start gap-2 text-sm text-slate-700">
							<Link className="hover:text-ink hover:underline" to="/examples">
								Examples
							</Link>
							<Link className="hover:text-ink hover:underline" to="/pricing">
								Pricing
							</Link>
							<Link className="hover:text-ink hover:underline" to="/status">
								Status
							</Link>
							<Link className="hover:text-ink hover:underline" to="/faq">
								FAQ
							</Link>
							<a
								className="hover:text-ink hover:underline"
								href="https://api.textformatter.pro"
								target="_blank"
								rel="noreferrer"
							>
								API
							</a>
						</div>
					</div>
					<div>
						<p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
							Company
						</p>
						<div className="mt-3 flex flex-col items-start gap-2 text-sm text-slate-700">
							<Link className="hover:text-ink hover:underline" to="/blog">
								Blog
							</Link>
							<Link className="hover:text-ink hover:underline" to="/about">
								About
							</Link>
							<Link className="hover:text-ink hover:underline" to="/contact">
								Contact
							</Link>
						</div>
					</div>
					<div>
						<p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">
							Legal
						</p>
						<div className="mt-3 flex flex-col items-start gap-2 text-sm text-slate-700">
							<Link className="hover:text-ink hover:underline" to="/terms">
								Terms of Use
							</Link>
							<Link className="hover:text-ink hover:underline" to="/privacy">
								Privacy Policy
							</Link>
							<button
								type="button"
								className="text-left hover:text-ink hover:underline cursor-pointer"
								onClick={onOpenCookieSettings}
							>
								Cookie settings
							</button>
						</div>
					</div>
				</div>
				<div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-slate-200 pt-5 text-xs text-slate-500 sm:flex-row sm:items-center">
					<p>Use Text Formatter to turn raw text into clean, reusable content.</p>
					<p>
						&#169; 2026 Created by{" "}
						<a
							href="https://www.hromnik.com"
							target="_blank"
							rel="noreferrer"
							className="font-medium text-slate-700 underline underline-offset-2 hover:text-ink"
						>
							www.hromnik.com
						</a>
					</p>
				</div>
			</div>
		</footer>
	);
}
